import { Api } from "@mcleod/core";
import { AutogenLayoutProcessCommissionsParameters } from "./autogen/AutogenLayoutProcessCommissionsParameters";
import { CommissionsProcessStepperProps } from "./ProcessCommissionsStepper";
import { ReportData, Snackbar } from "@mcleod/components";

export class ProcessCommissionsParameters extends AutogenLayoutProcessCommissionsParameters {
    private summaries: ReportData[] = [];

    async printSummaries(props: Partial<CommissionsProcessStepperProps>) {
        const response = await Api.post("lme/settlement/commissions/print-summaries", {
            begin_date: props.startDate,
            end_date: props.endDate,
            payees: props.payees
        });
        const data  = response?.data[0];
        this.summaries = [];

        if (data?.summary_data != undefined) {
            this.summaries.push(data.summary_data);
        }
        if (data?.warnings) {
            for (let i = 0; i < data?.warnings.length; i++) {
                Snackbar.showWarningSnackbar(data?.warnings[i]);
            }
        }
        return response;
    }
}
